import { render, staticRenderFns } from "./AudioModal.vue?vue&type=template&id=205cee94&scoped=true"
import script from "./AudioModal.vue?vue&type=script&lang=js"
export * from "./AudioModal.vue?vue&type=script&lang=js"
import style0 from "./AudioModal.vue?vue&type=style&index=0&id=205cee94&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cee94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205cee94')) {
      api.createRecord('205cee94', component.options)
    } else {
      api.reload('205cee94', component.options)
    }
    module.hot.accept("./AudioModal.vue?vue&type=template&id=205cee94&scoped=true", function () {
      api.rerender('205cee94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/HundredDayOathDetail/components/AudioModal.vue"
export default component.exports